import { useSelector } from "react-redux";
import { Operators } from "../../../../../components/condition/model/Operators";
import { createConditionTree } from "../../../../../components/condition/utils/createConditionTree";
import { findConditionById } from "../../../../../components/condition/utils/findConditionById";
import { isNullCondition } from "../../../../../components/condition/utils/isNullCondition";

export const ConditionTypes = {
  SpecialCondition: "SPECIAL_CONDITION",
  KeyCondition: "KEY_CONDITION",
  NotKeyCondition: "NOT_KEY_CONDITION",
};

function getType(conditionNode) {
  if (conditionNode.operator === Operators.comparisonSPECIAL_EQ) {
    return ConditionTypes.SpecialCondition;
  } else if (conditionNode.isKeyCondition) {
    return ConditionTypes.KeyCondition;
  } else {
    return ConditionTypes.NotKeyCondition;
  }
}
export function useGetCondition(userGroupUniqueName, conditionId) {
  const userGroupDetail = useSelector(
    (rootState) => rootState.userGroup.userGroupDetails[userGroupUniqueName]?.value
  );

  const membershipCondition = userGroupDetail?.membershipCondition;
  const membershipConditionTree = createConditionTree(membershipCondition, null);
  const conditionNode = findConditionById(membershipConditionTree, conditionId);

  if (isNullCondition(conditionNode)) {
    return null;
  } else {
    return {
      type: getType(conditionNode),
      node: conditionNode,
    };
  }
}
